import SponsorsContainer from './sponsors_container';

const Sponsors = SponsorsContainer;
export default Sponsors;
